import type React from "react";
import HeaderSimple from "../components/header-simple";

type Props = {
  readonly children: React.ReactNode;
};
export default function SimpleLayout({ children }: Readonly<Props>) {
  return (
    <div className="flex h-screen w-full flex-col text-text-base bg-bg">
			<HeaderSimple />
			{children}
		</div>);

}